import { Shop } from "../model/Shop";
import { ShopDataGrid } from "../components/ShopDataGrid";
import { getShops } from "../service/ShopService";
import { useEffect, useState } from "react";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function ShopList() {
  const [shops, setShops] = useState<Shop[]>([]);
  const [deleteShop, setDeleteShop] = useState<boolean>(true);
  const navigate = useNavigate();
  useEffect(() => {
    if (deleteShop) {
      getShops().then((shops) => setShops([...shops]));
      setDeleteShop(false);
    }
  }, [deleteShop]);
  const handleClick = () => {
    navigate(`/create`);
  };

  return (
    <>
      <Box sx={{ textAlign: "right", m: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleClick}
          className="ce"
        >
          Créer un magasin
        </Button>
      </Box>
      <ShopDataGrid shops={shops} setDeleteShop={setDeleteShop} />
    </>
  );
}
